import lodashIsEmpty from 'lodash/isEmpty';

const page_limit = 10;

/**
 * sauce: https://stackoverflow.com/a/58437909 and adjusted via chatgpt to support array url param
 * @param {{[key: string]: string}} objectParams - object params
 * @param {{[key: string]: string[]}} arrayParams - array params
 * @returns
 */
function buildQueryString(objectParams = {}, arrayParams = {}) {
  const params = new URLSearchParams();
  // Append object-style params
  Object.entries(objectParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, String(value));
    }
  });
  // Append array-style params
  Object.entries(arrayParams).forEach(([key, values]) => {
    if (Array.isArray(values)) {
      values.forEach((value) => {
        if (value !== undefined && value !== null) {
          params.append(key, String(value));
        }
      });
    }
  });
  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
}

function getLimitAndOffset(page_number, returnObject) {
  if (returnObject) {
    return {
      limit: page_limit,
      offset: (page_number - 1) * page_limit,
    };
  }

  return `limit=${page_limit}&offset=${(page_number - 1) * page_limit}`;
}

function getUrlParameterFromFilter({
  categoryFilter = [],
  page, // number
  parentCategory,
  startWithAmpersand, // boolean
  tagFilter = [],
  whenFilter,
}) {
  let urlParams = '';
  tagFilter.forEach((tag) => {
    const rootSeparator = urlParams || startWithAmpersand ? '&' : '?';
    if (tag.value) {
      urlParams += `${rootSeparator}${tag.paramName}=${tag.value}`;
    } else if (tag.values) {
      tag.values.forEach((tagVal) => {
        const separator = urlParams || startWithAmpersand ? '&' : '?';
        urlParams += `${separator}${tag.paramName}=${tagVal.value}`;
      });
    }
  });
  const separator = urlParams || startWithAmpersand ? '&' : '?';
  if (!lodashIsEmpty(categoryFilter)) {
    // intended, bcs it will always contain 1 object just to match with tag filter format
    const category = categoryFilter[0];
    urlParams += `${separator}tags=${category.value}`;
  }
  if (lodashIsEmpty(whenFilter)) {
    urlParams += `${separator}open_only=false`;
  } else {
    urlParams += `${separator}open_only=true&order_date=${whenFilter.date}&order_time=${whenFilter.time}`;
  }
  if (!lodashIsEmpty(parentCategory)) {
    urlParams += `${separator}product_type=${parentCategory.value}`;
  }
  if (page) {
    urlParams += `${separator}${getLimitAndOffset(page)}`;
  }
  return urlParams;
}

function getUrlParameter(url) {
  // Remove the scheme (pickupcustomerapp://) and split the remaining part by '?' to get the query string
  const queryString = url?.split('?')?.[1];

  // Split the query string by '&' to get individual key-value pairs
  const pairs = queryString?.split?.('&');

  // Initialize an empty object to hold the parameters
  let params = {};

  // Loop through the key-value pairs and split by '=' to get the key and value
  pairs?.forEach?.((pair) => {
    const [key, value] = pair.split('=');
    params[key] = value;
  });

  return params;
}

function getUrlStringPath(url = '') {
  if (!url) return '';
  // Remove protocol and domain
  const pathWithQuery = url.replace(/^[a-zA-Z]+:\/\/[^/]+/, '');
  // Remove query string and hash
  const pathOnly = pathWithQuery.split(/[?#]/)[0] || '';
  // Remove leading slashes and normalize repeated slashes
  return pathOnly.replace(/^\/+/, '').replace(/\/+/g, '/');
}

export default {
  page_limit,
  buildQueryString,
  getLimitAndOffset,
  getUrlParameter,
  getUrlParameterFromFilter,
  getUrlStringPath,
};
